import { useLayoutContext } from "arkh";
import { useMemo } from "react";

export function useSuggestionItemLayout() {
  const layout = useLayoutContext();
  const size = 140;

  return useMemo(
    () => ({
      width: size,
      height: size + layout.space.small + layout.space.medium + 30,
      size,
    }),
    [layout.space.medium, layout.space.small]
  );
}
